import axios from "axios";
import { responseError } from "./UtilService";

const api_url = process.env.REACT_APP_API_URL + "/marcas";

export async function getMarcas(nombre = '', incluyeInactivos = false) {
    let params = "";
    if (nombre) {
        params += "?nombre="+nombre;
    }
    if (incluyeInactivos) {
        params += (params===""?"?estado=T":"&estado=T");
    }
    try {
        let resp = await axios.get(api_url+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err, "Hubo un error al obtener datos de marcas desde el servidor.");
    }
}

export async function nuevaMarca(data) {
    try {
        let resp = await axios.post(api_url,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar la marca en el servidor.");
            }
            //develver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //develver error de red
        }
        return resp;
    }
}

export async function editarMarca(id, data) {
    try {
        let resp = await axios.put(api_url+`/${id}`,data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar la marca en el servidor.");
            }
            //devolver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //devolver error de red
        }
        return resp;
    }
}

export async function deleteMarca(id) {
    try {
        let resp = await axios.delete(api_url+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al borrar la marca en el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function getMarca(id) {
    try {
        let resp = await axios.get(api_url+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err, "Hubo un error al obtener la marca en el servidor.");
    }
}